import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useFailedLoginDialogOpenState } from './failed-login-dialog.hooks';
import { useLocalization } from '@im/react-localization';

export function FailedLoginDialog() {
  const [open, setOpen] = useFailedLoginDialogOpenState();
  const { translate } = useLocalization();

  return (
    <Dialog
      aria-labelledby="failed-login-dialog-title"
      onClose={() => {
        setOpen(false);
      }}
      open={open}
    >
      <DialogTitle>
        <img alt="" src="/cep/assets/img/logo-ingram-blue.png" width={200} />
        <IconButton
          aria-label="close"
          onClick={() => {
            setOpen(false);
          }}
          sx={{
            position: 'absolute',
            right: (theme) => theme.spacing(1),
            top: (theme) => theme.spacing(1),
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <p>{translate('OktaWidget.FailedLoginRedirect', { 0: '3' })}</p>
      </DialogContent>
    </Dialog>
  );
}
